import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography, Button } from '@material-ui/core';
import { MdOutlineSelectAll } from 'react-icons/md';
import { IoArrowBackCircle } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserPreferences } from '../../redux/actions/projectsActions';
import { setActiveProjectId } from '../../core/services/authService';
import Loader from '../common/Loader';

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: 'center',
    marginTop: theme.spacing(10),
  },
  message: {
    maxWidth: 600,
    margin: 'auto',
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  buttonBox: {
    marginTop: theme.spacing(4),
  },
}));

function TaskNotFound({ history }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { activeProject } = useSelector(state => state.projects);

  const [loading, setLoading] = useState(false);

  const handleSelectAppProjectsButton = () => {
    setLoading(true);

    dispatch(updateUserPreferences('', null))
      .then(() => {
        setActiveProjectId(null);

        window.location.reload();
      })
      .catch(() => setLoading(false));
  };

  if (loading) return <Loader />;

  return (
    <Box className={classes.root}>
      <Typography variant="h3" component="h1" gutterBottom>
        Task Not Found
      </Typography>
      {activeProject && (
        <Typography variant="subtitle1" className={classes.message}>
          We couldn’t find the task in the selected project.
          <br />
          The link may be incorrect, or it may have been attached to a different project.
        </Typography>
      )}
      <Box className={classes.buttonBox}>
        <Button
          startIcon={<IoArrowBackCircle />}
          onClick={() => history.push('/tasks')}
          className="button"
          variant="outlined"
          color="primary"
        >
          Back to Tasks
        </Button>

        {activeProject && (
          <Button
            onClick={() => handleSelectAppProjectsButton()}
            className={`button ${classes.button}`}
            startIcon={<MdOutlineSelectAll />}
            variant="contained"
            color="primary"
          >
            Select All Projects
          </Button>
        )}
      </Box>
    </Box>
  );
}

TaskNotFound.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(TaskNotFound);
